"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7001],{

/***/ 89844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ConfirmModal": function() { return /* binding */ ConfirmModal; },
  "DynamicConfirmModal": function() { return /* binding */ DynamicConfirmModal; },
  "default": function() { return /* binding */ modals_ConfirmModal; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../ui-library/dist/index.js + 203 modules
var dist = __webpack_require__(78197);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/modals/ConfirmModal.styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        " !important;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  text-align: center;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  text-align: center;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  text-align: center;\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: ",
        ";\n  margin-top: ",
        ";\n\n  button {\n    flex-grow: 1;\n    max-width: 50%;\n  }\n\n  @media (max-width: ",
        ") {\n    display: block;\n\n    button {\n      display: block;\n      width: 100%;\n      max-width: unset;\n      margin-bottom: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var iconVariants = {
    warning: {
        color: (0,theme/* color */.$_)("notice_500")
    },
    info: {
        color: (0,theme/* color */.$_)("info_500")
    }
};
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8c5d3896-0"
})(_templateObject());
var StyledIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8c5d3896-1"
})(_templateObject2(), (0,theme/* color */.$_)("notice_500"), (0,theme/* fontSize */.JB)("xl7"), function(param) {
    var variant = param.variant;
    return variant && iconVariants[variant] && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), iconVariants[variant].color);
});
var StyledTitle = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-8c5d3896-2"
})(_templateObject3(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* color */.$_)("midnight_500"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl3"));
var StyledText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-8c5d3896-3"
})(_templateObject4(), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"));
var StyledActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8c5d3896-4"
})(_templateObject5(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("md"));

;// CONCATENATED MODULE: ./components/modals/ConfirmModal.tsx










var ConfirmModal = function(param) {
    var isOpen = param.isOpen, close = param.close, title = param.title, text = param.text, action = param.action, actionId = param.actionId, confirmText = param.confirmText, cancelText = param.cancelText, _closeAfterConfirm = param.closeAfterConfirm, closeAfterConfirm = _closeAfterConfirm === void 0 ? true : _closeAfterConfirm, _icon = param.icon, icon = _icon === void 0 ? pro_light_svg_icons/* faWarning */.e7M : _icon, _iconVariant = param.iconVariant, iconVariant = _iconVariant === void 0 ? "warning" : _iconVariant;
    var t = (0,useI18n/* useI18n */.Q)("common").t;
    var ref = (0,react.useState)(false), submitting = ref[0], setSubmitting = ref[1];
    var handleConfirmClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ex;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setSubmitting(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            action(actionId || 1)
                        ];
                    case 2:
                        _state.sent();
                        if (closeAfterConfirm) {
                            setSubmitting(false);
                            close();
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        ex = _state.sent();
                        setSubmitting(false);
                        throw ex;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleConfirmClick() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (isOpen) {
            setSubmitting(false);
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Modal */.u_, {
        buttonsFullWidth: true,
        closeable: false,
        isOpen: isOpen,
        title: "",
        buttonCancel: {
            onClick: close,
            label: cancelText || t("confirmModal.actions.cancel")
        },
        buttonSuccess: {
            onClick: handleConfirmClick,
            isLoading: submitting,
            label: confirmText || t("confirmModal.actions.confirm")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                variant: iconVariant,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: icon
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                children: title || t("confirmModal.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                children: text || t("confirmModal.text")
            })
        ]
    });
};
/* harmony default export */ var modals_ConfirmModal = (ConfirmModal);
var DynamicConfirmModal = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 89844));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89844)
            ];
        }
    },
    ssr: false
});


/***/ }),

/***/ 17001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OfferAlertConfirmSaveModal": function() { return /* binding */ OfferAlertConfirmSaveModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22970);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _fortawesome_pro_light_svg_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38914);
/* harmony import */ var components_modals_ConfirmModal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89844);
/* harmony import */ var context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23357);
/* harmony import */ var hooks_useI18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39105);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);








var OfferAlertConfirmSaveModal = function(param) {
    var isOpen = param.isOpen, close = param.close, onConfirm = param.onConfirm, onSignupClick = param.onSignupClick;
    var t = (0,hooks_useI18n__WEBPACK_IMPORTED_MODULE_3__/* .useI18n */ .Q)("job-offer-list").t;
    var user = (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_2__/* .LoggedUserContext */ .Vi).user;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modals_ConfirmModal__WEBPACK_IMPORTED_MODULE_1__["default"], {
        isOpen: isOpen,
        close: close,
        action: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                if (user) {
                    onConfirm();
                } else {
                    onSignupClick();
                }
                return [
                    2
                ];
            });
        }),
        icon: _fortawesome_pro_light_svg_icons__WEBPACK_IMPORTED_MODULE_7__/* .faQuestionCircle */ .Fuz,
        iconVariant: "info",
        cancelText: t("job-offer-list.alert-confirm-save-modal.action-cancel"),
        confirmText: user ? t("job-offer-list.alert-confirm-save-modal.action-confirm") : t("job-offer-list.alert-confirm-save-modal.action-confirm-not_logged"),
        title: t("job-offer-list.alert-confirm-save-modal.title"),
        text: user ? t("job-offer-list.alert-confirm-save-modal.text") : t("job-offer-list.alert-confirm-save-modal.text-not_logged")
    });
};
/* harmony default export */ __webpack_exports__["default"] = (OfferAlertConfirmSaveModal);


/***/ })

}]);